import React from "react";
import {
  Avatar,
  Card,
  Grid,
  ActionIcon,
  createStyles,
  Skeleton,
} from "@mantine/core";
import {
  Location,
  Technology,
  Email,
  People,
  Filter,
  Link,
} from "@/components/Svg";

const useStyles = createStyles((theme) => ({
  para: {
    fontSize: "14px",
    lineHeight: "24px",
  },
  title: {
    fontSize: "18px",
    lineHeight: "22px",
    color: "#5C5C5C",
  },

  path: {
    fill: "white",
  },
}));

export default function OrganizationSmallCardSkeleton({
  organization,
  ...props
}) {
  const { theme, classes } = useStyles();
  return (
    <Card
      padding='lg'
      style={{
        borderRadius: "12px",
      }}
      {...props}
      withBorder>
      <Grid>
        <Grid.Col span={12}>
          <div className='flex items-center'>
            <Skeleton height={60} circle />
            <div className='flex flex-col ms-4'>
              <Skeleton height={24} mb={4} width={130} radius='xl' />
              <Skeleton height={17} mt={4} width={150} radius='xl' />
            </div>
          </div>
          <div className='flex justify-between items-center mt-[16px]'>
            <div className='flex flex-col'>
              <div className='flex items-center text-primary'>
                <Skeleton height={16} mt={8} mx={4} width={100} radius='xl' />
              </div>
              <div className='flex items-center text-primary'>
                <Skeleton height={16} mt={8} mx={4} width={100} radius='xl' />
              </div>
            </div>
            <div className='flex'>
              <Skeleton height={32} circle />
              <Skeleton height={32} circle className='ms-[7px]' />
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
